<template>
  <div class="asta-tavolo">
    <div class="area-logs">
      <asta-log small hasEffect v-if="astaLogsLast" :log="astaLogsLast">
      </asta-log>
      <v-btn
        @click="showAstaLogs"
        x-small
        depressed
        rounded
        class="btn-logs text-none"
        ><v-icon>more_horiz</v-icon></v-btn
      >
    </div>
    <asta-tavolo-cerchio
      v-if="tavoloLayout == Constants.TAVOLO_LAYOUT.CERCHIO"
    ></asta-tavolo-cerchio>
    <asta-tavolo-griglia v-else></asta-tavolo-griglia>

    <div
      v-if="listoneStatus != 1 && !listoneStatusClosed"
      class="listoneStatus-wrapper"
    >
      <div :class="listoneStatusClass">
        <v-btn
          depressed
          small
          class="listoneStatus-close"
          icon
          @click="closelistoneStatus()"
        >
          <v-icon small>close</v-icon>
        </v-btn>
        {{ listoneStatusMsg }}
      </div>
    </div>

    <div class="top-left-corner"></div>
    <div class="top-right-corner"></div>
  </div>
</template>

<script>
import db from "../js/db";
import Vuex from "vuex";
import AstaLog from "./common/AstaLog";
import Constants from "../js/constants";
import mixins from "../js/mixins";
import AstaTavoloCerchio from "./AstaTavoloCerchio.vue";
import AstaTavoloGriglia from "./AstaTavoloGriglia.vue";

export default {
  name: "asta-tavolo",
  mixins: [mixins],
  components: {
    AstaLog,
    AstaTavoloCerchio,
    AstaTavoloGriglia,
  },
  data() {
    return {
      listoneStatusClosed: false,
    };
  },
  computed: {
    listoneStatusMsg() {
      switch (this.listoneStatus) {
        case 0:
          return "Listone non ancora disponibile. " + this.listoneExpectedText;
        case 2:
          return (
            "Listone provvisorio. Ricordiamo che sarà ufficiale non appena saranno diramati i convocati. " +
            this.listoneExpectedText
          );
        default:
          return "";
      }
    },
    listoneExpectedText() {
      let output = "";
      if (this.listoneConf && this.listoneConf.tsExpected) {
        let dateExpected = new Date(this.listoneConf.tsExpected * 1000); // date object
        console.log(dateExpected);
        var options = { year: "numeric", month: "long", day: "numeric" };
        output =
          "Il listone ufficiale dovrebbe essere disponibile intorno al " +
          dateExpected.toLocaleDateString("it-IT", options);
      }
      return output;
    },
    listoneStatus() {
      let status = 1;
      if (this.listoneConf && this.listoneConf.status) {
        status = this.listoneConf.status;
      }
      return status;
    },
    listoneStatusClass() {
      return "listoneStatus listoneStatus-" + this.listoneStatus;
    },
    ...Vuex.mapGetters(["astaLogsLast", "tavoloLayout", "listoneConf"]),
  },
  methods: {
    showAstaLogs() {
      db.emit("showAstaLogs");
    },
    closelistoneStatus() {
      this.listoneStatusClosed = true;
    },
  },
  mounted() {
    console.log("--> AstaTavolo ready.");
  },
  destroyed() {
    console.log("<-- AstaTavolo destroyed.");
  },
};
</script>
<style lang="scss" scoped>
@import "../main.scss";

.asta-tavolo {
  // background: linear-gradient(white, transparent);
  // padding-top: 50px;
  // overflow: hidden;
  .area-logs {
    padding: 18px 5px 3px 5px;
    // background: white;
    margin-bottom: 10px;
    min-height: 40px;
    position: relative;
    display: flex;
    justify-content: center;
    .btn-logs {
      // position: absolute;
      // right: 5px;
      // top: 10px;
      // color: white;
      background: var(--v-navy-darken-1);
    }
  }
}

.top-left-corner {
  position: absolute;
  top: 5px;
  left: 10px;
  display: flex;
  flex-direction: column;
  .v-speed-dial__list {
    left: 10px;
  }
  .v-btn-toggle {
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);
    margin: 0 0px 6px 0;
    .v-item--active {
      color: var(--v-text-base);
    }
    .v-btn {
      margin: 0;
      opacity: 1;
      background: white;
    }
    &.icone-cerchi {
      .v-btn {
        &:first-child i {
          font-size: 10px;
        }

        i {
          font-size: 15px;
        }

        &:last-child i {
          font-size: 20px;
        }
      }
    }
  }
}

.listoneStatus-wrapper {
  padding-top: 15px;
  .listoneStatus {
    margin: 0 15px;
    border-radius: 3px;
    padding: 20px 10px 10px 10px;
    position: relative;
    .listoneStatus-close {
      position: absolute;
      right: 0;
      top: 0;
      color: white;
    }
    &.listoneStatus-0 {
      color: #e57373;
      background: #ffcdd2;
    }
    &.listoneStatus-2 {
      color: #ffe0b2;
      background: #ffe0b25c;
    }
  }
}
</style>
